import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { EuiForm } from '@elastic/eui';
import FormGroupDescription from '../../../components/formGroupDescription';
import TextAreaField from '../../../components/Form/TextAreaField';
import { useDispatch, useSelector } from 'react-redux';
import { restaurantSettingsAPI } from '../../../api/restaurantSettings/restaurantSettingsAPI';
import * as types from '../../../reduxStore/types/outlet';
import { userHasPermission } from '../../../helper/auth';

const ContactUs = (props) => {
    const { restaurantResponse, fetchRestaurant } = props;
    const {
        handleSubmit,
        control,
        watch,
        reset,
        setValue,

        formState: { isDirty, errors },
    } = useForm();
    const dispatch = useDispatch();
    const permissions = useSelector((state) => state.permission.permission);
    const restaurantDescriptions = useSelector((state) => state.auth.restaurantDescriptions);

    useEffect(() => {
        if (!userHasPermission(permissions, '/restaurant-settings', 'write')) return;
        if (isDirty) {
            dispatch({
                type: 'set-portal-active',
                payload: {
                    portalActive: {
                        resetChanges: resetChanges,
                        submit: handleSubmit(onSubmit),
                    },
                },
            });
        } else {
            dispatch({
                type: 'set-portal-active',
                payload: {
                    portalActive: {},
                },
            });
        }
    }, [isDirty]);

    useEffect(() => {
        if (restaurantResponse && restaurantResponse.restaurant) {
            resetChanges();
        }
    }, [restaurantResponse]);

    const resetChanges = () => {
        let defaultValue = {};
        let restaurantData = restaurantResponse.restaurant;
        defaultValue.languages = restaurantData.languages.map((item, index) => ({
            label: item.language_label,
            language: item.language,
            language_label: item.language_label,
        }));

        let translationObject = {
            contact_us: {},
        };

        for (const language_label in restaurantData.translations.contact_us) {
            translationObject.contact_us[language_label] = restaurantData.translations.contact_us[language_label];
        }

        defaultValue.translations = translationObject;

        reset({
            ...defaultValue,
        });
    };

    const onSubmit = (data) => {
        dispatch(restaurantSettingsAPI('contact_us', data)).then((res) => {
            if (res.success) {
                dispatch({
                    type: types.SET_PORTAL_ACTIVE,
                    payload: {
                        portalActive: {},
                    },
                });
                dispatch({
                    type: types.SET_PORTAL_ACTIVE_TAB_SWITCHED,
                    payload: {
                        tabSwitched: false,
                    },
                });
                fetchRestaurant();
            } else {
                alert(res.message);
            }
        });
    };

    return (
        <>
            <EuiForm component='form' onSubmit={handleSubmit(onSubmit)}>
                <FormGroupDescription
                    title={restaurantDescriptions?.contact_us?.display_name}
                    description={restaurantDescriptions?.contact_us?.description}
                >
                    {watch('languages') &&
                        watch('languages').length > 0 &&
                        watch('languages').map((item, index) => (
                            <TextAreaField
                                errors={errors}
                                isInvalid={
                                    errors.translations &&
                                    errors.translations.contact_us &&
                                    errors.translations.contact_us.hasOwnProperty(item.language)
                                }
                                error={
                                    errors.translations &&
                                    errors.translations.contact_us &&
                                    errors.translations.contact_us.hasOwnProperty(item.language) &&
                                    errors.translations.contact_us[item.language]
                                        ? errors.translations.contact_us[item.language].message
                                        : ''
                                }
                                label={index === 0 ? <strong>Contact us</strong> : ''}
                                name={`translations.contact_us.${item.language}`}
                                placeholder={`Write contact us: ${item.language_label}`}
                                rules={{ required: 'Please write contact us' }}
                                control={control}
                                watch={watch}
                                rows={4}
                            />
                        ))}
                </FormGroupDescription>
            </EuiForm>
        </>
    );
};

export default ContactUs;
